export default __webpack_public_path__ + "static/media/im.f08793e3.svg";